"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));

var _useClientDevice = _interopRequireDefault(require("../../customHooks/useClientDevice"));

var _Box = _interopRequireDefault(require("../Box/Box"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable no-plusplus */

/* eslint-disable react/jsx-props-no-spreading */
var DropdownWrapper = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "Dropdown__DropdownWrapper",
  componentId: "sc-55sjyg-0"
})(["overflow-y:auto;-webkit-overflow-scrolling:touch;"]);
var DEFAULT_COLUMNS_PER_ROW = {
  MOBILE: 1,
  TABLET: 2,
  DESKTOP: 3
};
var DEFAULT_ROW_HEIGHT = 40;
var DEFAULT_CONTAINER_HEIGHT = 300;
var DEFAULT_BUFFER = 20;

var getContainerHeight = function getContainerHeight(_ref) {
  var dropdownContainerHeight = _ref.dropdownContainerHeight,
      columns = _ref.columns,
      values = _ref.values,
      dropdownRowHeight = _ref.dropdownRowHeight;
  if (Math.ceil(values.length / columns) * dropdownRowHeight < dropdownContainerHeight) return "auto";
  return dropdownContainerHeight;
}; // Dropdown list is now a "virtual list" to help with performance of rendering very large lists. The idea is to only render
// the 'slice' of the array that needs to be displayed. ie react only has to worry about rendering chunks of the very large array
// rather than the whole list (even if it is hidden from view)


var Dropdown = function Dropdown(_ref2) {
  var _ref2$columsPerDevice = _ref2.columsPerDeviceType,
      columsPerDeviceType = _ref2$columsPerDevice === void 0 ? {} : _ref2$columsPerDevice,
      _ref2$dropdownRowHeig = _ref2.dropdownRowHeight,
      dropdownRowHeight = _ref2$dropdownRowHeig === void 0 ? DEFAULT_ROW_HEIGHT : _ref2$dropdownRowHeig,
      _ref2$dropdownContain = _ref2.dropdownContainerHeight,
      dropdownContainerHeight = _ref2$dropdownContain === void 0 ? DEFAULT_CONTAINER_HEIGHT : _ref2$dropdownContain,
      _ref2$dropdownBuffer = _ref2.dropdownBuffer,
      dropdownBuffer = _ref2$dropdownBuffer === void 0 ? DEFAULT_BUFFER : _ref2$dropdownBuffer,
      values = _ref2.values,
      _ref2$checkboxColour = _ref2.checkboxColour,
      checkboxColour = _ref2$checkboxColour === void 0 ? "primary.0" : _ref2$checkboxColour,
      isSelected = _ref2.isSelected,
      toggleSelection = _ref2.toggleSelection,
      selected = _ref2.selected,
      maxSelect = _ref2.maxSelect;
  var clientWidthType = (0, _useClientDevice["default"])();

  var _useState = (0, _react.useState)(0),
      scrollTop = _useState[0],
      setScrollTop = _useState[1];

  var handleScroll = function handleScroll(e) {
    return setScrollTop(e.target.scrollTop);
  };

  var columnsPerRow = (0, _extends2["default"])({}, DEFAULT_COLUMNS_PER_ROW, columsPerDeviceType); // innerHeight is the height of the full length of the list

  var innerHeight = Math.ceil(values.length / columnsPerRow[clientWidthType]) * dropdownRowHeight; // startIndex is the start of the chunk of the full list to be rendered

  var startIndex = Math.max(Math.floor(scrollTop / dropdownRowHeight) * columnsPerRow[clientWidthType] - dropdownBuffer * columnsPerRow[clientWidthType], // buffer of 20 rows
  0 // don't render past the beginning of the list
  ); // endIndex is the end of the chunk to be displayed

  var endIndex = Math.min(values.length - 1, // don't render past the end of the list
  Math.floor((scrollTop + dropdownContainerHeight) * columnsPerRow[clientWidthType] / dropdownRowHeight) + dropdownBuffer * columnsPerRow[clientWidthType] // buffer of 20 rows
  );
  var allRows = [];
  var row = [];

  var _loop = function _loop(i) {
    var category = values[i];
    row.push( /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      height: dropdownRowHeight,
      width: [1 / columnsPerRow.MOBILE, 1 / columnsPerRow.TABLET, 1 / columnsPerRow.DESKTOP],
      py: 2,
      pr: 2,
      colour: checkboxColour,
      id: category.id,
      checked: isSelected(category.id),
      onChange: function onChange() {
        return toggleSelection(category.id);
      },
      onBlur: function onBlur() {
        return null;
      },
      key: category.id,
      value: category.id,
      label: function label() {
        return /*#__PURE__*/_react["default"].createElement(_Text["default"], null, category.name);
      },
      disabled: !isSelected(category.id) && selected.length >= maxSelect
    }));

    if (row.length === columnsPerRow[clientWidthType]) {
      allRows.push( /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
        width: 1,
        flexWrap: "nowrap"
      }, [].concat(row)));
      row = [];
    }
  };

  for (var i = startIndex; i <= endIndex; i++) {
    _loop(i);
  }

  allRows.push( /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    width: 1,
    flexWrap: "nowrap"
  }, [].concat(row)));
  row = [];
  return /*#__PURE__*/_react["default"].createElement(DropdownWrapper, {
    width: 1 / 1,
    p: 3,
    position: "absolute",
    bg: "light.0",
    zIndex: "1",
    elevation: 2,
    overflowY: "scroll",
    borderRadius: 4,
    height: getContainerHeight({
      dropdownContainerHeight: dropdownContainerHeight,
      values: values,
      dropdownRowHeight: dropdownRowHeight,
      columns: columnsPerRow[clientWidthType]
    }),
    onScroll: handleScroll
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    height: innerHeight,
    pt: startIndex * dropdownRowHeight / columnsPerRow[clientWidthType]
  }, allRows));
};

var _default = Dropdown;
exports["default"] = _default;